export type MMPArray = [number, number, number];

/**
 * Converts raw input array to Array(3), replacing any undefined/NaN with 0
 */
function zeroPadArray3(arr: number[]): MMPArray {
  return arr
    .concat(Array(3).fill(0))
    .slice(0, 3)
    .map((v) => (isNaN(v) ? 0 : v)) as MMPArray;
}

/**
 * @name regExpMatchArrayToVersionMMPArr
 * @description Converts the result of a regex match to MMPArray
 */
function regExpMatchArrayToMMPArr(
  v: RegExpMatchArray | null,
  defaultValue: MMPArray
) {
  return v === null
    ? defaultValue
    : (zeroPadArray3(v.slice(1).map((str) => parseInt(str, 10))) as MMPArray);
}

function parseInput(inputVersion: number | string = 0) {
  if (typeof inputVersion === 'number')
    return zeroPadArray3(
      inputVersion
        .toString()
        .split('.')
        .map((str) => parseInt(str, 10))
    );
  const v = inputVersion.match(/(\d+).(\d+).?(\d+)?/);
  return regExpMatchArrayToMMPArr(v, [0, 0, 0]);
}

function compareVersions(mmpArr: MMPArray, testArray: MMPArray): boolean {
  return (
    /* major gt */
    mmpArr[0] > testArray[0] ||
    /* major eq, minor gte */
    (mmpArr[0] === testArray[0] && mmpArr[1] >= testArray[1]) ||
    /* major eq, minor eq, patch gte */
    (mmpArr[0] === testArray[0] &&
      mmpArr[1] === testArray[1] &&
      mmpArr[2] >= testArray[2])
  );
}

export const isIOS = (inputTestVersion: number | string = 0) => {
  let mmpArr: MMPArray = [12, 0, 0];

  // test version
  const testArray = parseInput(inputTestVersion);

  if (/iP(hone|od|ad)/.test(navigator.platform)) {
    // supports iOS 2.0 and later: <https://bit.ly/TJjs1V>
    const appVersion = navigator.appVersion;
    // const appVersion = "5.0 (iPhone; CPU iPhone OS 13_2_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.3 Mobile/15E148 Safari/604.1";
    var v = appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    mmpArr = regExpMatchArrayToMMPArr(v, mmpArr);
  }

  return (
    ([
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)) &&
    compareVersions(mmpArr, testArray)
  );
};

export default isIOS;
